import * as React from 'react';
import styled from 'styled-components';
import { SectionLessonHero } from './components/SectionLessonHero';
import { SectionLessonSideBar } from './components/SectionLessonSideBar';
import { SectionLessonListingNotAuthorExercise } from './components/SectionLessonListingNotAuthorExercise';
import { SectionLessonListingHasAuthorExercise } from './components/SectionLessonListingHasAuthorExercise';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import {
  GrammarTopicTypeByUrl,
  GrammarTopicTypeContent,
  GrammarTopicTypeEnum,
} from '@doltech/domains/grammar/lib/shared/utils/constants';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';

const Container = styled.article``;

const Body = styled.section`
  background-color: ${colorsV2.white100};

  .grammar-landing-theory-content {
    display: grid;
    grid-auto-flow: row;
    row-gap: 20px;
    column-gap: 36px;
    padding: 24px 0;

    ${fromScreen(768)} {
      grid-auto-flow: column;
      grid-template-columns: 228px minmax(0, 1fr);
      padding: 40px 60px;
    }

    ${fromScreen(1024)} {
      max-width: 1080px;
      padding: 40px 0;
      margin: 0 auto;
    }
  }
`;

interface GrammarLandingExercisePageProps {
  data?: any;
  blogPageData?: any;
  otherUrlInfo?: any;
  query?: any;
  isLoggedIn?: boolean;
  exerciseList?: any;
}

export const GrammarLandingExercisePage = (props: GrammarLandingExercisePageProps) => {
  const { data, exerciseList, blogPageData, otherUrlInfo, query, isLoggedIn } = props;
  const { topicList } = data || {};
  const selectedTopicId = query?.topic
    ? GrammarTopicTypeByUrl[query?.topic]
    : GrammarTopicTypeEnum.CAC_THI_TRONG_TIENG_ANH;
  const currentPageIndex = query?.page - 1 || 0;

  return (
    <Container>
      <SectionLessonHero
        title={blogPageData?.dol?.tocTitle || blogPageData?.dol?.title}
        description={blogPageData?.dol?.description}
      />
      <Body>
        <div className="grammar-landing-theory-content">
          <SectionLessonSideBar
            defaultTopicId={selectedTopicId}
            topicData={topicList?.data}
            topicUrl={blogPageData?.url}
          />
          {isLoggedIn ? (
            <SectionLessonListingHasAuthorExercise
              title={GrammarTopicTypeContent[selectedTopicId]}
              topicId={selectedTopicId}
              otherUrlInfo={otherUrlInfo}
              topicUrl={blogPageData?.url}
              currentPageIndex={currentPageIndex}
              initData={exerciseList?.data?.content}
            />
          ) : (
            <SectionLessonListingNotAuthorExercise
              initData={exerciseList?.data}
              title={GrammarTopicTypeContent[selectedTopicId]}
              topicId={selectedTopicId}
              topicUrl={blogPageData?.url}
              currentPageIndex={currentPageIndex}
              otherUrlInfo={otherUrlInfo}
            />
          )}
        </div>
      </Body>
    </Container>
  );
};
